import { createContext } from "react";

const MaterialContext = createContext();

export default MaterialContext;
